export default __webpack_public_path__ + "static/media/wallet.26a8f490.png";